<template>
  <div class="hello">

   <b-carousel
      id="carousel-1"
      v-model="slide"
      :interval="4000"
      indicators
      background="#ababab"
      img-width="1024"
      img-height="480"
      style="text-shadow: 1px 1px 2px #333;"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
    >
      <!-- Text slides with image -->
      <a xxv-b-modal.video-1>
        <b-carousel-slide
          img-src="../assets/img/slide-1.jpg"
        >
          <img src="../assets/img/play.svg" class="play" />
        </b-carousel-slide>

        <b-carousel-slide
          img-src="../assets/img/slide-1.jpg"
        >
          <img src="../assets/img/play.svg" class="play" />
        </b-carousel-slide>
      </a>

      <!-- <b-carousel-slide
        img-src="../assets/img/slide-1.jpg"
      ></b-carousel-slide> -->
    </b-carousel>

    <b-modal id="video-1" centered hide-footer busy="true" modalClass="ww-video-modal">
      <template v-slot:default="">
        <b-container class="">
          <b-row>
            <b-col>
              <b-embed
                type="iframe"
                aspect="16by9"
                src="https://www.youtube.com/embed/PZ-6Q4vY0dA?autoplay=1&rel=0"
                allowfullscreen
              ></b-embed>
            </b-col>
          </b-row>
        </b-container>
      </template>
    </b-modal>

    <b-container class="ww-section">
      <b-row>
        <b-col>

          <h1 id="faqs">become a dealer</h1>

          <p class="subhead">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Lorem ipsum dolor sit amet, consectetuer adipis.</p>
        </b-col>
      </b-row>
    </b-container>


  </div>
</template>

<script>
import {gmapApi} from 'vue2-google-maps'


export default {
  name: 'Details',
  props: {
    msg: String
  },

  data: function () {
    return {
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      zipCode: '',

      infoOptions: {
        content: '',
        //optional: offset infowindow so it visually sits nicely on top of our marker
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      mapStyles: {

        styles: [
                    {
                      "elementType": "geometry",
                      "stylers": [
                        {
                          "color": "#f5f5f5"
                        }
                      ]
                    },
                    {
                      "elementType": "labels.icon",
                      "stylers": [
                        {
                          "visibility": "off"
                        }
                      ]
                    },
                    {
                      "elementType": "labels.text.fill",
                      "stylers": [
                        {
                          "color": "#616161"
                        }
                      ]
                    },
                    {
                      "elementType": "labels.text.stroke",
                      "stylers": [
                        {
                          "color": "#f5f5f5"
                        }
                      ]
                    },
                    {
                      "featureType": "administrative.land_parcel",
                      "elementType": "labels.text.fill",
                      "stylers": [
                        {
                          "color": "#bdbdbd"
                        }
                      ]
                    },
                    {
                      "featureType": "poi",
                      "elementType": "geometry",
                      "stylers": [
                        {
                          "color": "#eeeeee"
                        }
                      ]
                    },
                    {
                      "featureType": "poi",
                      "elementType": "labels.text.fill",
                      "stylers": [
                        {
                          "color": "#757575"
                        }
                      ]
                    },
                    {
                      "featureType": "poi.park",
                      "elementType": "geometry",
                      "stylers": [
                        {
                          "color": "#e5e5e5"
                        }
                      ]
                    },
                    {
                      "featureType": "poi.park",
                      "elementType": "labels.text.fill",
                      "stylers": [
                        {
                          "color": "#9e9e9e"
                        }
                      ]
                    },
                    {
                      "featureType": "road",
                      "elementType": "geometry",
                      "stylers": [
                        {
                          "color": "#ffffff"
                        }
                      ]
                    },
                    {
                      "featureType": "road.arterial",
                      "elementType": "labels.text.fill",
                      "stylers": [
                        {
                          "color": "#757575"
                        }
                      ]
                    },
                    {
                      "featureType": "road.highway",
                      "elementType": "geometry",
                      "stylers": [
                        {
                          "color": "#dadada"
                        }
                      ]
                    },
                    {
                      "featureType": "road.highway",
                      "elementType": "labels.text.fill",
                      "stylers": [
                        {
                          "color": "#616161"
                        }
                      ]
                    },
                    {
                      "featureType": "road.local",
                      "elementType": "labels.text.fill",
                      "stylers": [
                        {
                          "color": "#9e9e9e"
                        }
                      ]
                    },
                    {
                      "featureType": "transit.line",
                      "elementType": "geometry",
                      "stylers": [
                        {
                          "color": "#e5e5e5"
                        }
                      ]
                    },
                    {
                      "featureType": "transit.station",
                      "elementType": "geometry",
                      "stylers": [
                        {
                          "color": "#eeeeee"
                        }
                      ]
                    },
                    {
                      "featureType": "water",
                      "elementType": "geometry",
                      "stylers": [
                        {
                          "color": "#c9c9c9"
                        }
                      ]
                    },
                    {
                      "featureType": "water",
                      "elementType": "labels.text.fill",
                      "stylers": [
                        {
                          "color": "#9e9e9e"
                        }
                      ]
                    }
      ]},

      markers: [
                  {
                    "id": 0,
                    "distance": 0,
                    "name": "Wilsonart Americas",
                    "country": "United States",
                    "address1": "2501 Wilsonart Drive",
                    "address2": "",
                    "city": "Temple",
                    "state": "TX",
                    "zip": 76504,
                    "phone1": "800-433-3222",
                    "phone2": "254-207-7000",
                    "fax": "254-207-3209",
                    "lat": 31.14533,
                    "lng": -97.35225,
                    //"position": new window.google.maps.LatLng(31.14533, -97.35225),
                  },
                  {
                    "id": 1,
                    "distance": 0,
                    "name": "Wilsonart",
                    "country": "United States",
                    "address1": "5333 S. Kyrene Road",
                    "address2": "Suite 103",
                    "city": "Tempe",
                    "state": "AZ",
                    "zip": 85283,
                    "phone1": "800-764-6366",
                    "phone2": "480-921-9906",
                    "fax": "480-921-0268",
                    "lat": 33.37408,
                    "lng": -111.94425,
                    //"position": new window.google.maps.LatLng(33.37408, -111.94425),
                  },
                  {
                    "id": 2,
                    "distance": 0,
                    "name": "Wilsonart",
                    "country": "United States",
                    "address1": "13911 East Gannet Street",
                    "address2": "P.O. Box 2336",
                    "city": "Santa Fe Springs",
                    "state": "CA",
                    "zip": "90670-5326",
                    "phone1": "562-921-7426",
                    "phone2": "",
                    "fax": "254-207-8822",
                    "lat": 33.89625,
                    "lng": -118.03385,
                    //"position": new window.google.maps.LatLng(33.89625, -118.03385),
                  },
                  {
                    "id": 3,
                    "distance": 0,
                    "name": "Wilsonart",
                    "country": "United States",
                    "address1": "6740 Broadway Ave.",
                    "address2": "Unit A",
                    "city": "Jacksonville",
                    "state": "FL",
                    "zip": 32254,
                    "phone1": "800-432-6057",
                    "phone2": "",
                    "fax": "904-695-0796",
                    "lat": 30.33123,
                    "lng": -81.75765,
                    //"position": new window.google.maps.LatLng(30.33123, -81.75765),
                  },
                  {
                    "id": 4,
                    "distance": 0,
                    "name": "Wilsonart",
                    "country": "United States",
                    "address1": "1331 N.W. 82nd Ave.",
                    "address2": "",
                    "city": "Miami",
                    "state": "FL",
                    "zip": 33126,
                    "phone1": "800-432-6057",
                    "phone2": "",
                    "fax": "305-477-2545",
                    "lat": 25.78541,
                    "lng": -80.32811,
                    //"position": new window.google.maps.LatLng(25.78541, -80.32811),
                  },
                  {
                    "id": 5,
                    "distance": 0,
                    "name": "Wilsonart",
                    "country": "United States",
                    "address1": "7414 Kingspointe Parkway",
                    "address2": "Suite 800",
                    "city": "Orlando",
                    "state": "FL",
                    "zip": "32819-8576",
                    "phone1": "800-432-6057",
                    "phone2": "",
                    "fax": "407-363-7122",
                    "lat": 28.460276,
                    "lng": -81.440721,
                    //"position": new window.google.maps.LatLng(28.460276, -81.440721),
                  },
                  {
                    "id": 6,
                    "distance": 0,
                    "name": "Wilsonart",
                    "country": "United States",
                    "address1": "8818 E. Adamo Drive",
                    "address2": "",
                    "city": "Tampa",
                    "state": "FL",
                    "zip": 33619,
                    "phone1": "800-432-6057",
                    "phone2": "",
                    "fax": "813-247-1247",
                    "lat": 27.9495708,
                    "lng": -82.3573919,
                    //"position": new window.google.maps.LatLng(27.9495708, -82.3573919),
                  },
                  {
                    "id": 7,
                    "distance": 0,
                    "name": "Wilsonart",
                    "country": "United States",
                    "address1": "2323 Park Central Blvd.",
                    "address2": "",
                    "city": "Decatur",
                    "state": "GA",
                    "zip": 30035,
                    "phone1": "770-593-2424",
                    "phone2": "",
                    "fax": "770-593-0545",
                    "lat": 33.7198621,
                    "lng": -84.1740111,
                    //"position": new window.google.maps.LatLng(33.7198621, -84.1740111),
                  },
                  {
                    "id": 8,
                    "distance": 0,
                    "name": "Wilsonart",
                    "country": "United States",
                    "address1": "29 Concord Street",
                    "address2": "",
                    "city": "North Reading",
                    "state": "MA",
                    "zip": "01864",
                    "phone1": "978-664-5230",
                    "phone2": "",
                    "fax": "978-664-4514",
                    "lat": 42.5632144,
                    "lng": -71.125026,
                    //"position": new window.google.maps.LatLng(42.5632144, -71.125026),
                  },
                  {
                    "id": 9,
                    "distance": 0,
                    "name": "Wilsonart",
                    "country": "United States",
                    "address1": "50768 Varsity Court",
                    "address2": "",
                    "city": "Wixom",
                    "state": "MI",
                    "zip": 48393,
                    "phone1": "248-960-3388",
                    "phone2": "",
                    "fax": "248-960-9922",
                    "lat": 42.5162404,
                    "lng": -83.5524869,
                    //"position": new window.google.maps.LatLng(42.5162404, -83.5524869),
                  },
                  {
                    "id": 10,
                    "distance": 0,
                    "name": "Wilsonart",
                    "country": "United States",
                    "address1": "9201 Wyoming Avenue North",
                    "address2": "Suite 100",
                    "city": "Brooklyn Park",
                    "state": "MN",
                    "zip": 55445,
                    "phone1": "877-424-4358",
                    "phone2": "763-424-1151",
                    "fax": "763-424-4383",
                    "lat": 45.1218708,
                    "lng": -93.3825321,
                    //"position": new window.google.maps.LatLng(45.1218708, -93.3825321),
                  },
                  {
                    "id": 11,
                    "distance": 0,
                    "name": "Wilsonart",
                    "country": "United States",
                    "address1": "98 County Road 122",
                    "address2": "",
                    "city": "Oxford",
                    "state": "MS",
                    "zip": 38655,
                    "phone1": "662-513-0293",
                    "phone2": "",
                    "fax": "662-513-0300",
                    "lat": 34.428315,
                    "lng": -89.5235147,
                    //"position": new window.google.maps.LatLng(34.428315, -89.5235147),
                  },
                  {
                    "id": 12,
                    "distance": 0,
                    "name": "Wilsonart",
                    "country": "United States",
                    "address1": "11 Twosome Drive",
                    "address2": "",
                    "city": "Moorestown",
                    "state": "NJ",
                    "zip": "08057",
                    "phone1": "800-822-7613",
                    "phone2": "",
                    "fax": "856-866-1812",
                    "lat": 39.9779769,
                    "lng": -74.9751241,
                    //"position": new window.google.maps.LatLng(39.9779769, -74.9751241),
                  },
                  {
                    "id": 13,
                    "distance": 0,
                    "name": "Wilsonart",
                    "country": "United States",
                    "address1": "999 South Oyster Bay Road",
                    "address2": "Suite 305",
                    "city": "Bethpage (Hicksville)",
                    "state": "NY",
                    "zip": 11714,
                    "phone1": "866-455-8297",
                    "phone2": "516-935-6980",
                    "fax": "516-935-6875",
                    "lat": 40.7561821,
                    "lng": -73.4980258,
                    //"position": new window.google.maps.LatLng(40.7561821, -73.4980258),
                  },
                  {
                    "id": 14,
                    "distance": 0,
                    "name": "Wilsonart",
                    "country": "United States",
                    "address1": "2500 International Street",
                    "address2": "",
                    "city": "Columbus",
                    "state": "OH",
                    "zip": 43228,
                    "phone1": "614-876-1515",
                    "phone2": "",
                    "fax": "614-876-0835",
                    "lat": 40.0038247,
                    "lng": -83.1303033,
                    //"position": new window.google.maps.LatLng(40.0038247, -83.1303033),
                  },
                  {
                    "id": 15,
                    "distance": 0,
                    "name": "Wilsonart",
                    "country": "United States",
                    "address1": "1641 Lebanon Pike Circle",
                    "address2": "",
                    "city": "Nashville",
                    "state": "TN",
                    "zip": 37210,
                    "phone1": "615-292-2188",
                    "phone2": "",
                    "fax": "615-292-7849",
                    "lat": 36.151997,
                    "lng": -86.715474,
                    //"position": new window.google.maps.LatLng(36.151997, -86.715474),
                  },
                  {
                    "id": 16,
                    "distance": 0,
                    "name": "Wilsonart",
                    "country": "United States",
                    "address1": "4051 La Reunion Parkway",
                    "address2": "Suite 140",
                    "city": "Dallas",
                    "state": "TX",
                    "zip": 75212,
                    "phone1": "214-634-2310",
                    "phone2": "",
                    "fax": "214-634-1435",
                    "lat": 32.7721,
                    "lng": -96.8929122,
                    //"position": new window.google.maps.LatLng(32.7721, -96.8929122),
                  },
                  {
                    "id": 17,
                    "distance": 0,
                    "name": "Wilsonart",
                    "country": "United States",
                    "address1": "552 Garden Oaks",
                    "address2": "",
                    "city": "Houston",
                    "state": "TX",
                    "zip": 77018,
                    "phone1": "713-576-5500",
                    "phone2": "",
                    "fax": "713-576-5515",
                    "lat": 29.825113,
                    "lng": -95.408558,
                    //"position": new window.google.maps.LatLng(29.825113, -95.408558),
                  },
                  {
                    "id": 18,
                    "distance": 0,
                    "name": "Wilsonart",
                    "country": "United States",
                    "address1": "17745 Lookout Rd",
                    "address2": "Bldg 2, Suite 230",
                    "city": "Schertz",
                    "state": "TX",
                    "zip": 78154,
                    "phone1": "844-297-5591",
                    "phone2": "210-564-1500",
                    "fax": "210-564-1510",
                    "lat": 29.6048966,
                    "lng": -98.2948544,
                    //"position": new window.google.maps.LatLng(29.6048966, -98.2948544),
                  },
                  {
                    "id": 19,
                    "distance": 0,
                    "name": "Wilsonart",
                    "country": "United States",
                    "address1": "400 Boundary Blvd.",
                    "address2": "",
                    "city": "Algona",
                    "state": "WA",
                    "zip": 98001,
                    "phone1": "855-305-1854",
                    "phone2": "",
                    "fax": "855-305-1855",
                    "lat": 47.2926319,
                    "lng": -122.2493413,
                    //"position": new window.google.maps.LatLng(47.2926319, -122.2493413),
                  },
                  {
                    "id": 20,
                    "distance": 0,
                    "name": "Wilsonart",
                    "country": "Canada",
                    "address1": "6255 Cantay Road",
                    "address2": "Units 2 & 3",
                    "city": "Mississauga",
                    "state": "ON",
                    "zip": "L5R 3Z4",
                    "phone1": "905-565-1255",
                    "phone2": "",
                    "fax": "905-565-1280",
                    "lat": 43.622686,
                    "lng": -79.69528566,
                    //"position": new window.google.maps.LatLng(43.622686, -79.69528566),
                  }
                ]
    }
  },

  mounted () {
    this.$refs.mapRef.$mapPromise.then((map) => {
      console.log(map);
      for( var i=0; i<this.markers.length; i++){
        this.markers[i].position = new window.google.maps.LatLng(this.markers[i].lat, this.markers[i].lng);
      }
      this.$forceUpdate();
    })
  },

  computed : {

    google: gmapApi,

    sorted_markers() {
      let tempMarkers = [];
      for( var i=0; i<this.markers.length; i++){
          let tempMarker = this.markers[i];
          tempMarkers.push(tempMarker);
      }
      return tempMarkers.sort((a, b) => { return a.distance - b.distance;});


    }
  },

  methods: {

    //33.0126814
    //-96.8887202
    toggleInfoWindow: function(marker, idx) {
      var content = '';
      var addressString = '';
      var addressURL = 'https://www.google.com/maps/search/?api=1&query=';

      this.infoWindowPos = marker.position;

      content = marker.name
        + '<br />';

      addressString += marker.address1;
      addressURL += encodeURI(marker.address1) + '+';

      if (marker.address2 !== '') {
        addressString += '<br />' + marker.address2;
        addressURL += encodeURI(marker.address2) + '+';
      }

      addressString +='<br />' + marker.city + ', ' + marker.state + ' ' + marker.zip + '<br />';
      addressURL += encodeURI(marker.city) + '+' + encodeURI(marker.state) + '+' + encodeURI(marker.zip) + '+';

      content += '<a href="' + addressURL + '" target="_blank">' + addressString + '</a>';

      if (marker.phone1 !== '') {
        content += '<br /><a href="tel:' + marker.phone1 + '">' + marker.phone1 + '</a>';
      }

      if (marker.phone2 !== '') {
        content += '<br /><a href="tel:' + marker.phone2 + '">' + marker.phone2 + '</a>';
      }

      this.infoOptions.content = content;

      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;

      }
    },

    getThings(lat, lng) {
      //alert(this.getLatLngByZipcode(75007));

      //var location = new window.google.maps.LatLng(33.0126814, -96.8887202);
      var location = new window.google.maps.LatLng(lat, lng);

      for (var j = 0; j < this.markers.length; j++){
        this.markers[j].distance = this.distance(location.lat(), location.lng(), this.markers[j].lat, this.markers[j].lng, 'M');
      }
    },

    distance(lat1, lon1, lat2, lon2, unit) {
      if ((lat1 == lat2) && (lon1 == lon2)) {
        return 0;
      }
      else {
        var radlat1 = Math.PI * lat1/180;
        var radlat2 = Math.PI * lat2/180;
        var theta = lon1-lon2;
        var radtheta = Math.PI * theta/180;
        var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        if (dist > 1) {
          dist = 1;
        }
        dist = Math.acos(dist);
        dist = dist * 180/Math.PI;
        dist = dist * 60 * 1.1515;
        if (unit=="K") { dist = dist * 1.609344 }
        if (unit=="N") { dist = dist * 0.8684 }
        return dist;
      }
    },

    getLatLngByZipcode(zipcode) {
        var geocoder = new window.google.maps.Geocoder();
        var address = zipcode;
        var latitude;
        var longitude;
        var vm = this;
        geocoder.geocode({ 'address': 'zipcode '+address }, function (results, status) {
            if (status == window.google.maps.GeocoderStatus.OK) {
                var latitude = results[0].geometry.location.lat();
                var longitude = results[0].geometry.location.lng();

                vm.getThings(latitude, longitude);
                //alert("Latitude: " + latitude + "\nLongitude: " + longitude);
            } else {
                alert('Please enter a valid Zip/Postal code.');
            }
        });
        return [latitude, longitude];
    },

    zipCodeLookup: function () {

      var newZip = this.zipCode;

      if(newZip.length > 4) {
        this.getLatLngByZipcode(newZip);
      } else {
        alert('Please enter a valid Zip/Postal code.');
      }
    }
  },

  watch: {
    // whenever question changes, this function will run
    // zipCode: function (newZip) {

    //   if(newZip.length > 4) {
    //     this.getLatLngByZipcode(newZip);
    //   } else {
    //     alert('Please enter a valid Zip/Postal code.');
    //   }
    // }
  },
}
</script>

<style lang="scss">
  #zipcode {
    background-image: url(../assets/img/magnifying.svg);
    background-size: 20px 20px;
    background-repeat: no-repeat;
    background-position: top 10px right;
  }
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.locations {
  overflow: scroll;
  height: 300px;
}

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
